import type { AxiosRequestConfig } from 'axios';

import type { QueryParams } from './params';
import type { Repo } from './repository';

// Merges pinned() into query of every call; explicit params override auth params to name another vendor
export function pinParams<T>(repo: Repo<T>, pinned: () => QueryParams): Repo<T> {
  const query = (params?: QueryParams): QueryParams => Object.assign({}, params, pinned());
  const config = (base?: AxiosRequestConfig): AxiosRequestConfig =>
    Object.assign({}, base, { params: query(base && (base.params as QueryParams | undefined)) });
  return {
    path: repo.path,
    client: repo.client,
    fetch: <R = T[]>(params?: QueryParams, base?: AxiosRequestConfig) => repo.fetch<R>(query(params), base),
    fetchOne: <R = T>(id: string | number, params?: QueryParams, base?: AxiosRequestConfig) => repo.fetchOne<R>(id, query(params), base),
    count: (params?: QueryParams, base?: AxiosRequestConfig) => repo.count(query(params), base),
    create: <R = T>(data: unknown, base?: AxiosRequestConfig) => repo.create<R>(data, config(base)),
    update: <R = T>(id: string | number, data: unknown, base?: AxiosRequestConfig) => repo.update<R>(id, data, config(base)),
    remove: <R = T>(id: string | number, base?: AxiosRequestConfig) => repo.remove<R>(id, config(base)),
  };
}
